import { IQueryParams } from '@/creditflowresearch/domain/vo/IQueryParams';
import { IProduct } from '@/creditflowresearch/domain/vo/Product';
import AbsProduct from '@/creditflowresearch/domain/Product/entities/AbsProduct';
import { parseProductIdsFromQuery } from '@/creditflowresearch/domain/Product/selectors/parseProductIdsFromQuery';
import { selectDefaultCorporateProduct } from '@/creditflowresearch/domain/Product/selectors/selectDefaultCorporateProduct';
import type { IProductSelectionContext } from '@/creditflowresearch/domain/Product/selectors/selectDefaultAbsProduct';

export const selectProductIdsForCorporateRoute = (
  query: IQueryParams,
  productsList: IProduct[],
  accessibleProductsIds: string[],
  hasAccess: boolean,
): string[] => {
  const productsParam = Array.isArray(query.products) ? query.products.join(',') : query.products ?? '';
  const queryString = productsParam.replace(AbsProduct.ABBREVIATION, '') || '';
  const queryProductIds = parseProductIdsFromQuery(queryString, productsList);

  if (queryProductIds.length > 0) {
    return queryProductIds;
  }

  const context: IProductSelectionContext = {
    requiredProductType: undefined,
    accessibleProductIds: accessibleProductsIds,
    productsList,
    hasAccess,
  };

  const defaultProductId = selectDefaultCorporateProduct(context);
  return defaultProductId ? [defaultProductId] : [AbsProduct.PRODUCT_ID];
};
